import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { FaUserShield, FaLock } from "react-icons/fa";
import "./AdminLogin.css";

import {loginUser} from "../../auth.js";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    // TEMP auth (replace with API later)
    if (username === "admin" && password === "admin123") {
      loginUser({
        name: "Admin",
        username: "admin",
      });

      setError("");
      navigate("/AdminDashboard"); // ✅ no state
    } else {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="admin-login-container d-flex justify-content-center align-items-center vh-100">
      <div className="login-card p-4 rounded shadow">
        <h2 className="text-center mb-4">VTAS Admin Login</h2>

        <form onSubmit={handleLogin}>
          <div className="form-group mb-3">
            <label>Username</label>
            <div className="input-group">
              <span className="input-group-text"><FaUserShield /></span>
              <input
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group mb-3">
            <label>Password</label>
            <div className="input-group">
              <span className="input-group-text"><FaLock /></span>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && <div className="alert alert-danger py-1">{error}</div>}

          <button className="btn btn-primary w-100 mt-3">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
